<template>
  <TransitionRoot as="template" :show="isOpen">
    <Dialog as="div" class="relative z-[1000]">
      <TransitionChild
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-300"
          leave-from="opacity-100"
          leave-to="opacity-0"
      >

        <div class="fixed inset-0 bg-black/50" />

      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto flex items-center justify-center p-4">

        <TransitionChild
            enter="ease-out duration-300"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="ease-in duration-300"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
            as="template"
        >

          <DialogPanel
              class="z-[1000] rounded-md w-full max-w-[550px] max-h-[90vh] overflow-y-auto flex flex-col gap-y-6 py-6 font-sans shadow-xl gap-3 glass-background bg-white/75"
          >
            <!-- Header -->
            <div class="flex justify-between items-center px-6">

              <DialogTitle class="text-lg opacity-70">Ausbildungsbetrieb Details</DialogTitle>

              <IconButton
                  :icon="XMarkIcon"
                  tabindex="-1"
                  @click="$emit('close')"
              />

            </div>

            <Devider />

            <!-- Company Name -->
            <h2 class="text-2xl font-normal px-6 highVoltage">{{ normalizeDisplayName(info.companycaption1) }}</h2>

            <div v-if="featuredQualifications.length" class="w-full px-6 flex gap-2 flex-wrap">
              <span
                  v-for="q in featuredQualifications"
                  :key="q.key"
                  class="qualification-badge !text-[16px] !px-2 !py-1"
              >
                <img v-if="q.image" :src="q.image" alt="icon-image" class="h-4 w-auto" />
                <component v-else-if="q.icon" :is="q.icon" class="size-4" />
                {{ q.label }}
              </span>
            </div>

            <!--
            <div class="flex flex-wrap gap-2 px-6">
                <span v-if="true" class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-sm font-medium bg-slate-100 text-slate-700 border-slate-200">
                  <BuildingOffice2Icon class="size-4 shrink-0" />
                  ZQ Hotelmanagement
                </span>

                <span v-if="true" class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-sm font-medium bg-slate-100 text-slate-700 border-slate-200">
                  <SparklesIcon class="size-4 shrink-0" />
                  ZQ Küchen- & Servicemanagement
                </span>

              <span v-if="true" class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-sm font-medium bg-slate-100 text-slate-700 border-slate-200">
                  <AcademicCapIcon class="size-4 shrink-0" />
                Duales Berufskolleg
              </span>
            </div>
            -->
            <!-- Über uns -->
            <div v-if="apprenticeship.aboutus?.length > 0" class="px-6">
              <h3 class="info-title">Über uns</h3>
              <p class="space-y-1">{{ apprenticeship.aboutus }}</p>
            </div>

            <!-- Qualifikationen -->
            <div v-if="apprenticeship.qualifications?.length > 0" class="px-6">
              <h3 class="info-title">Wir bieten dir</h3>
              <ul class="list-disc pl-5">
                <li v-for="q in apprenticeship.qualifications" :key="q">{{ q }}</li>
              </ul>
            </div>

            <!-- Wettbewerbe -->
            <!--
                     <div v-if="company.competitions?.length > 0" class="px-6">
                       <h3 class="info-title">Wir nehmen an folgenden Wettbewerben teil</h3>
                       <ul class="list-disc pl-5">
                         <li v-for="c in company.competitions" :key="c">{{ c }}</li>
                       </ul>
                     </div>
         -->
            <!-- Ausbildungsberufe -->
            <div v-if="apprenticeship.apprenticeships?.length > 0" class="px-6">
              <h3 class="info-title">Unsere Ausbildungsberufe</h3>
              <ul class="list-disc pl-5">
                <li v-for="job in apprenticeship.apprenticeships" :key="job">{{ job }}</li>
              </ul>
            </div>

            <!-- Weitere Hinweise -->
            <div v-if="apprenticeship.externalexampreparation || apprenticeship.trainingcourses" class="px-6">
              <h3 class="info-title">Weitere Hinweise</h3>
              <ul class="list-disc pl-5">
                <li v-if="apprenticeship.externalexampreparation">Wir bieten externe Prüfungsvorbereitungen und Schulungen an</li>
                <li v-if="apprenticeship.trainingcourses">Wir nehmen an Schulungen teil</li>
              </ul>
            </div>

            <Devider />

            <!-- Adresse & Kontakt -->
            <div class="px-6 gap-8  flex justify-between flex-row">
              <div class="flex justify-start flex-col gap-8 mt-auto">
                <div class="w-42 min-w-42">
                  <h3 class="info-title">
                    <MapPinIcon class="size-5 stroke-2"/>Adresse
                  </h3>
                  <ul class="normalText space-y-1 !p-0">
                    <li>{{ address.addressstreet }} {{ address.addresshousenumber }}</li>
                    <li>{{ address.postalcodecaption }} {{ address.citycaption }}</li>
                    <li>{{ address.statecaption }}</li>
                  </ul>
                </div>
                <div class="w-42 min-w-42">
                  <h3 class="info-title">
                    <EnvelopeIcon class="size-5 stroke-2"/>Kontakt
                  </h3>
                  <ul class="normalText space-y-1 !p-0">
                    <li v-for="contact in contacts" :key="contact.humanid">{{ contact.humanfirstname }} {{ contact.humanlastname }}</li>
                    <li class="break-words max-w-64">{{ email }}</li>
                    <li>{{ telefon }}</li>
                    <li v-if="website">
                      {{ website }}
                    </li>
                  </ul>
                </div>
              </div>

              <QRCodeDisplay :company="qrContact"/>

            </div>

          </DialogPanel>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>

</template>

<script setup>
import {defineProps, toRef, computed} from 'vue'
import { Dialog, DialogPanel, DialogTitle, TransitionRoot, TransitionChild } from '@headlessui/vue'
import { XMarkIcon, MapPinIcon, EnvelopeIcon } from '@heroicons/vue/24/outline'
import TopaBanner from '@/components/ui/TopaBanner.vue'
import Devider from "@/components/ui/Devider.vue";
import QRCodeDisplay from "@/components/ui/QRCodeDisplay.vue";
import IconButton from "@/components/ui/IconButton.vue";
import {useFeaturedQualifications} from "@/composables/useFeaturedQualfications";
import {getDisplayAddress} from "@/utils/getDisplayAddress";
import {normalizeDisplayName} from "@/utils/normalizeCompanyTitle";

const props = defineProps({
  company: Object,
  isOpen: Boolean
})

const featuredQualifications = useFeaturedQualifications(toRef(props, 'company'))

// Neues Schema: props.company ist das ganze Dokument
// { company, addresses, communications, humans, apprenticeship, ... }
const info = computed(() => props.company?.company ?? {})
const apprenticeship = computed(() => props.company?.apprenticeship ?? {})

// Hauptadresse, sonst Rechnungsadresse (gleiche Regel wie auf der Karte)
const address = computed(() => getDisplayAddress(props.company) ?? {})

// Ansprechpartner: alle Personen mit Namen
const contacts = computed(() =>
    (props.company?.humans ?? []).filter(h => h.humanfirstname || h.humanlastname)
)

// Kontaktdaten: erster Eintrag je Typ (die API liefert nur öffentliche)
const getCommunication = typeCaption =>
    props.company?.communications?.find(c => c.companycommunicationtypecaption === typeCaption)
        ?.companycommunicationentry ?? ""

const email = computed(() => getCommunication("E-Mail"))
const telefon = computed(() => getCommunication("Telefon"))
const website = computed(() => getCommunication("Webseite"))

// Flaches Kontaktobjekt für den QR-Code (QRCodeDisplay erwartet diese Felder)
const qrContact = computed(() => ({
  humanfirstname: contacts.value[0]?.humanfirstname ?? "",
  humanlastname: contacts.value[0]?.humanlastname ?? "",
  addressstreet: address.value.addressstreet,
  addresshousenumber: address.value.addresshousenumber,
  citycaption: address.value.citycaption,
  postalcodecaption: address.value.postalcodecaption,
  telefonNumber: telefon.value,
  emailAdress: email.value,
  website: website.value,
}))


</script>

<style scoped>
@import "@/styles/textStyle.css";
@import "@/styles/generalStyle.css";

ul {
  padding: 0 0 0 18px;
  margin: 0;
}

/* Scrollbar Track */
*::-webkit-scrollbar-track {
  background: transparent; /* macht den Track durchsichtig */
}

/* Optional: Scrollbar selbst (Thumb) */
*::-webkit-scrollbar {
  width: 8px; /* oder deine gewünschte Breite */
}

*::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3); /* Farbe des Scrollbars */
  border-radius: 4px;
  border: 2px solid transparent; /* optional für Abstand */
  background-clip: content-box; /* optional für Styling */
}

</style>